export default "__VITE_ASSET__c896bb18__"